// WorkingInSelect — WHERE a new catalog/product row goes: Standard, or one
// project's own (INF-8, Alex 2026-09-25). The value is a project id as a string,
// '' = Standard. A `project` login is `locked` to its one project: no Standard
// option, and the control is read-only.
//
// The app's top bar. The Onshape panel makes the same choice as the first pick
// of its cascade (Project ▸ Source ▸ …), from the same remembered value. Whoever
// renders it hands the value to setWorkingProject() (working-project.js), which
// stamps it on every write.
//
// Built on SelectCell (RULES.md rule 9). A locked login has nothing to pick, so it
// gets its project in words instead of a disabled control.
import SelectCell from './SelectCell.jsx';

const label = (p) => (p.customer ? `${p.code} · ${p.customer}` : p.code);

export default function WorkingInSelect({ value, onChange, projects = [], locked = false, style }) {
  if (locked) {
    const p = projects.find(x => String(x.id) === String(value));
    return (
      <span title="Everything you add belongs to your project." style={{ fontSize: 'var(--fs-small)', color: 'var(--th-text-body)', ...style }}>
        {p ? label(p) : 'Your project'}
      </span>
    );
  }
  return (
    <SelectCell
      title="Where new catalog and product rows go: Standard is visible to every project; a project keeps them to that project only."
      value={value}
      onChange={onChange}
      options={[{ value: '', label: 'Standard' }, ...projects.map(p => ({ value: String(p.id), label: label(p) }))]}
      style={{
        fontSize: 'var(--fs-small)', padding: '2px 6px', borderRadius: 4,
        border: '1px solid var(--th-border-subtle)', color: 'var(--th-text-body)', background: 'var(--th-row-even)',
        width: 'auto', maxWidth: 220, ...style,
      }}
    />
  );
}
